import { QuoteInfoTable } from 'routes/essential-workspace/components/quote-panel/quote/info-table';
import { QuoteError } from 'routes/essential-workspace/components/quote-panel/quote/quote-error';

export function QuoteRejectedDetails() {
  return (
    <div className="flex-y py-0 gap-2 text-center quote-details-min-height">
      <QuoteError />
      <QuoteInfoTable />
    </div>
  );
}
